import { injectIntl } from "react-intl";
import React, { memo, useEffect } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { 
    verifyMfaMail, 
    selectVerifyMailStatus, 
    selectVerifyMailErrorMessage, 
    resetMfaStatus 
} from "../../redux";
import { ReduxState } from "../../../../redux/types";
import paths from "../../../../helper/pathRoutes";
import { Formik } from 'formik';

function MfaMail() {
    const history = useHistory();
    const dispatch = useDispatch();

    const verifyMailStatus = useSelector(selectVerifyMailStatus);
    const verifyMailErrorMessage = useSelector(selectVerifyMailErrorMessage);

    useEffect(() => {
        dispatch(resetMfaStatus());
    }, [dispatch]);

    const initialValues = {
        mailCode: ''
    };

    // ★修正：必須チェックが走ったとき、同時にAPI側の古いエラー表示を削除する
    const validate = (values) => {
        const errors = {};
        if (!values.mailCode) {
            errors.mailCode = 'メール認証コードは必ず入力してください。';
            
            // Reduxのステータスを初期化
            dispatch(resetMfaStatus());
        } else if (values.mailCode.length !== 4 || !/^\d{4}$/.test(values.mailCode)) {
            errors.mailCode = 'メール認証コードは4桁の数字で入力してください。';
            dispatch(resetMfaStatus());
        }
        return errors;
    };

    const onSubmit = (values, { setSubmitting }) => {
        // 遷移元の情報を取得（空でもSaga側が自動検知するので安心ですが、一応渡しておきます）
        const fromPage = history.location?.state?.from || '';

        dispatch(verifyMfaMail({ 
            mailCode: values.mailCode, // バックエンドのキー名に合わせてください
            setSubmitting,
            from: fromPage
        }));
    };

    return (
        <div>
            <canvas id="confetti" style={{ display: 'none' }}></canvas>

            <div className="m-pager-title">
                <div className="m-pager-title__inner">
                    <p className="m-pager-title__inner__title">認証＞メール認証コード入力</p>
                </div>
            </div>
            <Formik
                initialValues={initialValues}
                validate={validate}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={onSubmit}
            >
                {propsFormik => (
                    <form id="form" onSubmit={propsFormik.handleSubmit}>
                        <div className="t-contents t-contents--bg-ivory">
                            <div className="o-entry" ref={el => el && el.style.setProperty('max-width', '700px', 'important')}>
                                <p
                                    className="m-animal-header__normal-title u-mb5"
                                    style={{ color: "#333" }}
                                >
                                    メール認証コード入力
                                </p>
                                <p
                                    className="m-animal-header__normal-title u-mb15"
                                    style={{ color: "#333", fontWeight: 'normal' ,fontSize:"16px"}}>
                                    メール認証コードを入力し、認証するボタンをクリックしてください。
                                </p>
                            </div>

                            <div className="u-mb20" style={{ width: "200px", display: "block", margin: "0 auto" }}>
                                <input 
                                    type="text" 
                                    name="mailCode"
                                    maxLength={4}
                                    style={{ width: "200px", display: "block", margin: "0 auto" }}
                                    className={`a-input-text ${propsFormik.errors.mailCode ? "is-required" : ""}`}
                                    placeholder="メール認証コード" 
                                    value={propsFormik.values.mailCode}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        propsFormik.setFieldValue('mailCode', onlyNums);
                                    }}
                                />
                                {propsFormik.errors.mailCode && (
                                    <span className="u-fwBold u-fz11 a-color--pink">
                                        {propsFormik.errors.mailCode}
                                    </span>
                                )}
                            </div>

                            {/* APIの検証エラー用（必須チェック失敗時は、自動的に非表示になります） */}
                            {verifyMailStatus === ReduxState.ERROR && verifyMailErrorMessage && (
                                <p className="has-text-centered" style={{ color: "rgb(255, 0, 0)", marginTop: "20px" }}>
                                    {verifyMailErrorMessage}
                                </p>
                            )}
                            
                            <div 
                                className="t-footer-contents__body" 
                                style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}
                            >
                                <button 
                                    type="button"
                                    className="a-button a-button--submit a-button--pc-w330 a-button--round u-fz16 js-validation" 
                                    style={{ width: "150px", margin: "unset" }}
                                    onClick={() => history.push(paths.mfa)}
                                >
                                    戻る
                                </button>
                                
                                <button 
                                    type="submit" 
                                    className="a-button a-button--submit a-button--pc-w330 a-button--round u-fz16 js-validation" 
                                    style={{ 
                                        width: "150px", 
                                        margin: "unset",
                                        opacity: 1,
                                        cursor: "pointer"
                                    }}
                                >
                                    {propsFormik.isSubmitting ? "認証中..." : "認証する"}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
}

export default memo(injectIntl(MfaMail));